import { render, staticRenderFns } from "./ProposalPublic.vue?vue&type=template&id=90b10cc4&scoped=true"
import script from "./ProposalPublic.vue?vue&type=script&lang=ts"
export * from "./ProposalPublic.vue?vue&type=script&lang=ts"
import style0 from "./ProposalPublic.vue?vue&type=style&index=0&id=90b10cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b10cc4",
  null
  
)

export default component.exports